// Copyright 2019-2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import ResourceTable from "./ResourceTable";

export default ResourceTable;
